import React from 'react'

const BizNotifi = () => {
  return (
    <>
    
    <div>
            <h1 className='text-2xl ml-3  text-[#272C34] font-bold'> Notifications</h1>
            <div className='my-4 mx-2'>
            <div className='flex justify-between'>
            <div className='my-2 flex'>
            <p className='md:px-3 text-[#272C34] md:pt-1 text-[12px] '>Send email alerts</p>
            <div class="relative -ml-4 md:ml-0 mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
                <div className='flex'>
                    <h5 className='text-[12px] text-[#272C34] my-1'>See notifications for</h5>
                    <select className='md:w-[18rem] w-[7rem] px-2 ml-3 h-[25px] bg-[#FBFEFF]  border border-gray-300 rounded-lg'>
                        <option>All</option>
                        <option>ok</option>
                    </select>
                </div>
                
            </div>
 
 
            </div>
               

               <div className='  '>

               <div className='my-4 md:mb-11 md:w-[100%] mx-3'>
              <div className='mybookings-img'>
                 <div className=' border border-gray-300 rounded-lg  account-form'>

             <div className='w-full  border-b border-gray-300  p-4'>
             <h1 className='text-sm   text-[#272C34] font-semibold'>Padel Buddy court name</h1>
             </div>  
             
             <div className='w-full  border-b border-gray-300 p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                             Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>  
             
             <div className='w-full  p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                              Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>               

                 </div>               
              </div>
 
            </div>


            <div className='my-4 md:mb-11 md:w-[100%] mx-3'>
              <div className='mybookings-img'>
                 <div className=' border border-gray-300 rounded-lg  account-form'>

             <div className='w-full  border-b border-gray-300  p-4'>
             <h1 className='text-sm   text-[#272C34] font-semibold'>Padel Buddy court name</h1>
             </div>  
             
             <div className='w-full  border-b border-gray-300 p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                             Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>  
             
             <div className='w-full p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                              Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>               

                 </div>               
              </div>
 
            </div>


            <div className='my-4 md:mb-11 md:w-[100%] mx-3'>
              <div className='mybookings-img'>
                 <div className=' border border-gray-300 rounded-lg  account-form'>

             <div className='w-full  border-b border-gray-300  p-4'>
             <h1 className='text-sm   text-[#272C34] font-semibold'>Padel Buddy court name</h1>
             </div>  
             
             <div className='w-full  border-b border-gray-300 p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                             Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>  
             
             <div className='w-full   p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                              Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>               

                 </div>               
              </div>
 
            </div>


            <div className='my-4 md:mb-11 md:w-[100%] mx-3'>
              <div className='mybookings-img'>
                 <div className=' border border-gray-300 rounded-lg  account-form'>

             <div className='w-full  border-b border-gray-300  p-4'>
             <h1 className='text-sm   text-[#272C34] font-semibold'>Padel Buddy court name</h1>
             </div>  
             
             <div className='w-full  border-b border-gray-300 p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                             Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>  
             
             <div className='w-full   p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                              Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>               

                 </div>               
              </div>
 
            </div>


            <div className='my-4 md:mb-11 md:w-[100%] mx-3'>
              <div className='mybookings-img'>
                 <div className=' border border-gray-300 rounded-lg  account-form'>

             <div className='w-full  border-b border-gray-300  p-4'>
             <h1 className='text-sm   text-[#272C34] font-semibold'>Padel Buddy court name</h1>
             </div>  
             
             <div className='w-full  border-b border-gray-300 p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                             Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>  
             
             <div className='w-full  p-4'>
             <h1 className='text-[12px] leading-[17px] text-[#272C34]'>
                                              Lorem ipsum dolor sit amet, consectetur
                                              adipiscing elit. Nunc posuere quam orci, sit
                                               amet congue risus consectetur a. Sed pellentesque 
                                               ligula eget purus condimentum, a fermentum purus congue.
                                                Nunc laoreet eget ex luctus eleifend. Ut non purus vel erat
                                                 aliquam sagittis eu vel augue. Fusce sed ligula a lectus
                                                  gravida hendrerit. Maecenas eget augue id justo hendrerit
                                                   consectetur. Vivamus malesuada maximus elit in feugiat. 
                                                   Maecenas volutpat ut dui quis pellentesque.</h1>
             </div>               

                 </div>               
              </div>
 
            </div>
               
              
               </div>

               {/* pagination  */}

              <div className='flex justify-between mt-3 md:mt-9'>
               <nav aria-label="Page navigation example">
  <ul class="inline-flex items-center -space-x-px">
    <li>
      <a href="#" class="block py-2 px-3 ml-0 leading-tight text-gray-500 text-[12px]   rounded-l-lg  hover:bg-gray-100 hover:text-gray-700  ">
        <span class="sr-only">Previous</span>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
      </a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight  text-[12px]    hover:bg-gray-100 hover:text-gray-700  ">1</a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500 text-[12px]    hover:bg-gray-100 hover:text-gray-700  ">2</a>
    </li>
    <li>
      <a href="#" aria-current="page" class=" text-gray-500  py-2 px-3 leading-tight text-[12px]  hover:bg-blue-100 hover:text-blue-700  ">3</a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500 text-[12px]    hover:bg-gray-100 hover:text-gray-700  ">4</a>
    </li>
    
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500 text-[12px]    hover:bg-gray-100 hover:text-gray-700  ">...</a>
    </li>
    <li>
      <a href="#" class="block py-2 px-3 leading-tight text-gray-500 text-[12px]   rounded-r-lg  hover:bg-gray-100 hover:text-gray-700  ">
        <span class="sr-only">Next</span>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
      </a>
    </li>
  </ul>
</nav>
<h3 className='text-gray-500 text-[12px] mt-3'>1 of 729</h3>
</div>




            </div>

     </>
  )
}

export default BizNotifi